import { computed } from 'vue'
import { useAuthLoginStore } from 'modules/authentication/stores/auth-login-store'
import useNotifyMessage from 'modules/shared/composables/useNotifyMessage'
import signInRequest from 'modules/authentication/models/signInRequest'
import authLoginRequest from 'modules/authentication/models/authLoginRequest'
import loginModel from 'modules/authentication/models/loginModel'
import mappings from 'modules/shared/models/mappings/mappings'

const useAuth = () => {
  const authLoginStore = useAuthLoginStore()
  const { notifyMessage } = useNotifyMessage()

  const authRequest = { ...signInRequest }

  const userProfile = computed(() => authLoginStore.userProfile)
  const currentAuthStatus = computed(() => authLoginStore.currentStatus)

  const authenticateUser = async (signInData) => {
    const payload = JSON.parse(JSON.stringify(authLoginRequest))

    payload.authLogin.authReference.environmentId = mappings.Agency.environmentId || ""
    payload.authLogin.authReference.userId = authLoginStore.userId || ""
    payload.authLogin.authReference.subscriptionId = ""
    payload.authLogin.authReference.companyId = authLoginStore.companyId || ""
    payload.authLogin.authReference.agencyId = authLoginStore.agencyId || ""

    payload.authLogin.authModal.type = "login"
    payload.authLogin.authModal.mode = ""

    payload.authLogin.authCredential = {
      method: "password",
      credentials: {
        username: signInData.username || "",
        password: signInData.password || ""
      }
    }

    payload.authLogin.authSession = {
      id: authLoginStore.authSession?.id || "",
      member: authLoginStore.authSession?.member || ""
    }

    payload.authLogin.authCallback = {
      url: "string",
      userId: "string",
      password: "string",
      auth: "string",
      retries: "string"
    }

    payload.authLogin.authNotify = {
      email: "string",
      sms: "",
      push: ""
    }

    const { data, success } = await authLoginStore.signInUser(payload)

    if (success) {
      if (data?.session) authLoginStore.setAuthSession(data.session)
      // el token ya fue seteado internamente por el store via pickAccessToken
    }

    return { success }
  }

  const signInUser = async (signInData) => {
    const loginType = 'login'
    const authProperty = 'authLogin'

    setRequestAuthData(loginType, authProperty, signInData)

    const { status, data } = await authLoginStore.signInUser(authRequest)

    if (status === 200) {
      authLoginStore.authenticateUser(data.data)
    } else {
      errorMessage(data)
    }

    return status === 200
  }

  const setRequestAuthData = (loginType, authProperty, data) => {
    authRequest.authLogin.authModal.type = loginType
    authRequest.authLogin[authProperty] = data
  }

  const errorMessage = (data) => {
    const { detail, error } = data
    const message = detail !== undefined ? detail : error.message
    notifyMessage('error', message, 'top-right')
  }

const checkAuthStatus = async () => {
  return await authLoginStore.checkAuthentication()
}

  const cloneLoginFields = () => {
    return JSON.parse(JSON.stringify(loginModel))
  }

  const logout = () => {
    authLoginStore.logout()
  }

  const getLoginFields = () => {
    return cloneLoginFields(loginModel).fields
  }

  return {
    userProfile,
    currentAuthStatus,

    authenticateUser,
    notifyMessage,
    checkAuthStatus,
    logout,
    getLoginFields
  }
}

export default useAuth